import {Howl, HowlOptions, Howler} from "howler";

enum EnumSoundType {
	Background = 'background',
	Effects = 'effects',
}

Howler.autoUnlock = true;

Howler.html5PoolSize = 10;
Howler.usingWebAudio = true;

export abstract class AudioControl {
	public static types = EnumSoundType
	public static FADE_DURATION = 1000;
	private static instances: Record<EnumSoundType, Howl>;

	public static INIT(type: EnumSoundType, options: HowlOptions): Howl {
		AudioControl.instances = AudioControl.instances || {};
		AudioControl.instances[ type ] = new Howl(options);
		const root = document.getElementById('root');

		if ( root ) {
			root.click()
		}
		return AudioControl.instances[ type ];
	}

	public static get SOUND_BG() {
		if ( !AudioControl.instances || !AudioControl.instances[ AudioControl.types.Effects ] ) {
			throw new Error('No backgrounds were initialized')
		}
		return AudioControl.instances[ EnumSoundType.Background ];
	}

	public static get SOUND_EFFECTS() {

		if ( !AudioControl.instances || !AudioControl.instances[ EnumSoundType.Effects ] ) {
			throw new Error('No sounds effect were initialized')
		}
		return AudioControl.instances[ AudioControl.types.Effects ];
	}

	public static get SOUND_EFFECTS_LOAD_WAITER() {
		return () => new Promise<void>((resolve, reject) => {
			if ( AudioControl.SOUND_EFFECTS.state() === 'loading' ) {
				AudioControl.SOUND_EFFECTS.once('load', () => {
					resolve();
				})
				AudioControl.SOUND_EFFECTS.once('loaderror', () => {
					reject();
				})
			} else {
				resolve();
			}
		})
	}

	public static BG_FADE_IN() {
		try {
			if ( AudioControl.SOUND_BG ) {
				const isIn = !!AudioControl.SOUND_BG.volume();

				if ( !isIn ) {
					AudioControl.SOUND_BG.fade(0, 1, AudioControl.FADE_DURATION);
				}
			}
		} catch (e: any) {
			console.log(e);
		}

	}

	public static BG_FADE_OUT() {
		try {
			const isIn = !!AudioControl.SOUND_BG.volume();

			if ( isIn ) {
				AudioControl.SOUND_BG.fade(1, 0, AudioControl.FADE_DURATION);
			}
		} catch ( e ) {
			console.log(e);
		}
	}

	public static SOUND_EFFECT_FADE_OUT() {
		try {
			const isIn = !!AudioControl.SOUND_EFFECTS.volume();

			if ( isIn ) {
				AudioControl.SOUND_EFFECTS.fade(1, 0, AudioControl.FADE_DURATION);
			}
		} catch ( e ) {
			console.log(e);
		}

	}

	public static SOUND_EFFECT_FADE_IN() {
		try {
			const isIn = !!AudioControl.SOUND_EFFECTS.volume();

			if ( !isIn ) {
				AudioControl.SOUND_EFFECTS.fade(0, 1, AudioControl.FADE_DURATION);
			}
		} catch ( e ) {
			console.log(e);
		}

	}

}
